var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "progress rounded-0 my-1", class: _vm.$style.progress },
    [
      _c("div", {
        staticClass: "progress-bar bg-success",
        style: _vm.progressStyle
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }